//#region src/quicksand_update_type.ts
var QuicksandUpdateType = /* @__PURE__ */ function(QuicksandUpdateType) {
	QuicksandUpdateType["Shown"] = "shown";
	QuicksandUpdateType["HiddenIndefinitely"] = "86ed-indefinitely";
	QuicksandUpdateType["HiddenUntilTomorrow"] = "86ed-temporarily";
	QuicksandUpdateType["UpdatedModAvailability"] = "updated-mod-availability";
	return QuicksandUpdateType;
}(QuicksandUpdateType || {});
//#endregion
export { QuicksandUpdateType };

//# sourceMappingURL=quicksand_update_type.js.map